import global from 'global';
var globalWindow = global.window;
globalWindow.STORYBOOK_ENV = 'web-components';